// « Agir au nom de » : représentation validée choisie par l'usager pour ses prochaines demandes
// (H7-02), mémorisée sur l'appareil ; null pour agir en son nom propre.
import { ecrireStockage, lireStockage } from '@cc/ui';
import { useCallback, useSyncExternalStore } from 'react';
import type { Representation } from './types';

const CLE = 'cc-citoyen:representation';
const ecouteurs = new Set<() => void>();
let courante: string | null = lireStockage<string>(CLE);

function abonner(e: () => void) {
  ecouteurs.add(e);
  return () => {
    ecouteurs.delete(e);
  };
}

export function useRepresentationActive(representations: Representation[] | undefined): [Representation | null, (id: string | null) => void] {
  const id = useSyncExternalStore(abonner, () => courante, () => null);
  const choisir = useCallback((v: string | null) => {
    courante = v;
    ecrireStockage(CLE, v);
    for (const e of ecouteurs) e();
  }, []);
  const active = id ? (representations ?? []).find((r) => r.id === id && r.valide) ?? null : null;
  return [active, choisir];
}

export const LIBELLES_TYPE_ENTITE: Record<string, string> = {
  entreprise: 'Entreprise',
  association: 'Association',
  personne: 'Personne',
};

export const LIBELLES_STATUT_REPRESENTATION: Record<string, string> = {
  en_attente: 'En attente de validation',
  validee: 'Validée',
  refusee: 'Refusée',
};
